<template>
  <div class="activityManagementList">
    <div class="filters">
      <el-form :inline="true">
        <el-form-item>
          <el-select v-model="village">
            <el-option
              v-for="(item,index) in villagetypes"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input class="searchInput" v-model="activityName" :placeholder="$t('lang.lab_activityName')"></el-input>
        </el-form-item>
        <el-button type="primary" @click="commit()">{{commitname}}</el-button>
      </el-form>
    </div>
    <el-card>
      <el-button slot="header" size="medium" type="primary" @click="jump()">{{$t('lang.btn_AddActivity')}}</el-button>
       <el-table
        :data="tableData"
        class="wid100"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
      >
        <el-table-column type="selection" width="55" v-if="this.activityManagementListcheckbox"></el-table-column>
        <el-table-column
          type="index"
          :index="indexMethod" align="center"
          :label="$t('lang.lab_index')"
          width="100px"
        ></el-table-column>
        <el-table-column prop="name" :label="$t('lang.lab_activityName')" width="300px">
          <template slot-scope="scope">
            <el-tooltip
              placement="top"
              effect="light"
              v-if="scope.row.name&&scope.row.name.length> require('@/config/enum').tableDatamaxlength"
              :disabled="false"
            >
              <div slot="content">
                <span >
                  {{ scope.row.name }}
                </span>
              </div>
              <div>
                {{ scope.row.name.substring(0, require('@/config/enum').tableDatamaxlength) | valueIsNull }}
                <span
                  v-if="scope.row.name.length>require('@/config/enum').tableDatamaxlength"
                >...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div>{{ scope.row.name | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="beginTime" :label="$t('lang.lab_beginTime')"></el-table-column>
        <el-table-column prop="endTime" :label="$t('lang.lab_endTime')"></el-table-column>
        <el-table-column prop="place" :label="$t('lang.lab_place')">
          <template slot-scope="scope">
            <el-tooltip
              placement="top"
              effect="light"
              v-if="scope.row.place&&scope.row.place.length> require('@/config/enum').tableDatamaxlength10"
              :disabled="false"
            >
              <div slot="content">
                <span >
                  {{ scope.row.place }}
                </span>
              </div>
              <div>
                {{ scope.row.place.substring(0, require('@/config/enum').tableDatamaxlength10) | valueIsNull }}
                <span
                  v-if="scope.row.place.length>require('@/config/enum').tableDatamaxlength10"
                >...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div>{{ scope.row.place | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="telephone" :label="$t('lang.lab_telephone')"></el-table-column>
        <el-table-column prop="cerCode" label="核销码"></el-table-column>
        <el-table-column :label="$t('lang.lab_operation')" prop="operation" :width="require('@/config/enum').opr_width3">
          <template slot-scope="scope">
            <el-button @click="seeActivity(scope.row.id)">{{detailname}}</el-button>
            <el-button @click="edit(scope.row.id)">{{modifyname}}</el-button>
            <el-button class="orange" @click="delete1(scope.row.id)">{{deletename}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount"
      />
    </el-card>
  </div>
</template>

<script>
/**
 *@ClassName:activityManagementList
 *@Description:活动管理
 *@author:刘彦辰
 *@Copyright:格众科技
 *@date:2020-02-21
 */
import { mapGetters } from 'vuex'

export default {
  name: '/manage/main.activityList',
  data() {
    return {
      pageCount: 0,
      pageNum: 1,
      pageSize: 10,
      tableData: [],
      showAllGarden: 0,
      chooseGarden: '0',
      activityName: '',
      multipleSelection: [], // 多选框
      activityManagementListcheckbox: require('@/config/enum').activityManagementListcheckbox, // 是否隐藏复选框
      commitname: require('@/config/enum').commitname,
      deletename: require('@/config/enum').deletename,
      detailname: require('@/config/enum').detailname,
      modifyname: require('@/config/enum').modifyname
    }
  },
  created() {
    setTimeout(() => {
      window.localStorage.setItem('addActivityManagementform', '')
      window.localStorage.setItem('addActivityManagementsaveData', '')
    }, 200)
    this.activityList()
  },
  activated() {
    this.activityList()
  },
  computed: {
      ...mapGetters({ village: 'gardenId', villagetypes: 'userGardenList' })
    },
  watch: {
    village: function (newFlag, oldFlag) {
      this.commit()
    }
  },
  methods: {
    // ID序号功能
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
    // 列表隔行变色
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // CHECKBOX
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 活动列表
    activityList() {
      let loading = this.$loading()
      this.$get(
        `/activity/?gardenId=${this.village}&pageSize=${this.pageSize}&pageNo=${this.pageNum}&keyword=${encodeURIComponent(this.activityName)}`
      ).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.tableData = res.list
            this.pageCount = res.pageCount
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 跳转用户参加页面
    seeActivity(id) {
      this.$router.push({ name: 'seeActivityManagement', query: { id: id } })
    },
    jump() {
      window.localStorage.setItem('addActivityManagementform', '')
      window.localStorage.setItem('addActivityManagementsaveData', '')
      this.$router.push({ name: 'addActivityManagement' })
    },
    // 点击换页
    handleCurrentChange(val) {
      this.pageNum = val
      this.activityList()
    },
    // 点击更改每页容量
    handleSizeChange(val) {
      this.pageNum = 1
      this.pageSize = val
      this.activityList()
    },
    edit(id) {
      window.localStorage.setItem('addActivityManagementform', '')
      window.localStorage.setItem('addActivityManagementsaveData', '')
      this.$router.push({ name: 'addActivityManagement', query: { id: id } })
    },
    commit() {
      this.pageNum = 1
      let loading = this.$loading()
      this.$get(
        `/activity/?keyword=${this.activityName}&gardenId=${this.village}&pageNo=${this.pageNum}&pageSize=${this.pageSize}`
      ).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.tableData = res.list
            this.pageCount = res.pageCount
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    delete1(id) {
      let loading = this.$loading()
        this.$confirm(
        this.$i18n.t('lang.lab_isdelete'),
        this.$i18n.t('lang.lab_prompt'),
        {
          confirmButtonText: this.$i18n.t('lang.btn_confirm'),
          cancelButtonText: this.$i18n.t('lang.btn_cancel'),
          type: 'warning'
        }
      ).then(() => {
        this.$delete(`/activity/` + id).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.$message({
                type: 'success',
                message: this.$i18n.t('lang.lab_del_success')
              })
              this.activityList()
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      })
      .catch(() => {
        loading.close()
        this.$message({
          type: 'info',
          message: this.$i18n.t('lang.lab_del_can')
        })
      })
    }
  }
}
</script>

<style lang='scss'>
</style>